// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1600":"f353d0b4","3184":"6efa2699","3375":"682f7cdf","8127":"33a888cd","8610":"8b5e88ee"}[chunkId] + ".chunk.css";
};